// extracted by mini-css-extract-plugin
export default {"scrollable-container":"a6BsEoe1qNKOl5nru8Jn"};